// Catalogo de funcionalidades (menus / sub-menus) controlaveis pela tela
// "Controle de Acesso" (v44). A `key` de cada no e EXATAMENTE o `name` usado
// na Sidebar.vue -> permite esconder o item do menu. `routes` lista os route
// names da funcionalidade -> permite o guard (routeHelpers.js) bloquear o
// acesso por URL.
//
// Itens DINAMICOS (canais, etiquetas, times, pastas, segmentos, empresas
// individuais) NAO entram aqui: sao gerados a partir de dados e nunca sao
// bloqueados individualmente por esta tela.

export const ACCESS_CONTROL_CATALOG = [
  // v91: Dashboard virou grupo com sub-páginas — cada uma controlável
  // individualmente (as keys batem com os `name` dos filhos na Sidebar.vue).
  {
    key: 'SegueDashboard',
    label: 'Dashboard (Segue)',
    children: [
      {
        key: 'SegueDashboard VisaoGeral',
        label: 'Visão Geral',
        routes: ['segue_dashboard', 'segue_dashboard_visao'],
      },
      { key: 'SegueDashboard Ofertas', label: 'Ofertas', routes: ['segue_dashboard_ofertas'] },
      { key: 'SegueDashboard Contratos', label: 'Contratos', routes: ['segue_dashboard_contratos'] },
      { key: 'SegueDashboard Equipe', label: 'Equipe', routes: ['segue_dashboard_equipe'] },
    ],
  },
  // v82: 'RealtimeReports' removido do catalogo (menu e rota /reports/live
  // apagados do sistema a pedido do Kairo 04/07/2026).
  {
    key: 'Inbox',
    label: 'Caixa de Notificações',
    routes: ['inbox_view', 'inbox_view_conversation'],
  },
  {
    key: 'Conversation',
    label: 'Conversas',
    children: [
      { key: 'All', label: 'Todas as Conversas', routes: ['home', 'inbox_conversation'] },
      {
        key: 'Mentions',
        label: 'Menções',
        routes: ['conversation_mentions', 'conversation_through_mentions'],
      },
      {
        key: 'Unattended',
        label: 'Não Atendidas',
        routes: ['conversation_unattended', 'conversation_through_unattended'],
      },
      {
        key: 'Folders',
        label: 'Pastas',
        routes: ['folder_conversations', 'conversations_through_folders'],
      },
      {
        key: 'Teams',
        label: 'Times',
        routes: ['team_conversations', 'conversations_through_team'],
      },
      {
        key: 'Channels',
        label: 'Canais',
        routes: ['inbox_dashboard', 'conversation_through_inbox'],
      },
      {
        key: 'Labels',
        label: 'Etiquetas',
        routes: ['label_conversations', 'conversations_through_label'],
      },
    ],
  },
  {
    key: 'Captain',
    label: 'Captain (IA)',
    routes: [
      'captain_assistants_index',
      'captain_assistants_responses_index',
      'captain_assistants_documents_index',
      'captain_tools_index',
      'captain_assistants_scenarios_index',
      'captain_assistants_playground_index',
      'captain_assistants_inboxes_index',
      'captain_assistants_responses_pending',
      'captain_assistants_settings_index',
      'captain_assistants_create_index',
    ],
  },
  { key: 'Kanban', label: 'Kanban', routes: ['kanban_index'] },
  // v105: funcionalidades FORA da sidebar, agora controlaveis por perfil.
  // Sem `routes` (nao sao telas): o gating e feito direto nos componentes
  // (ConversationBox.vue -> Simulador; Dashboard.vue -> ChatInterno).
  { key: 'Simulador', label: 'Simulador CLT (botão na conversa)' },
  { key: 'ChatInterno', label: 'Chat Interno (balão da equipe)' },
  // v106: menu Simulador (standalone) e Ranking de vendas
  { key: 'Simulador Menu', label: 'Simulador (menu lateral)', routes: ['simulador_index'] },
  { key: 'Ranking', label: 'Ranking (pódium de vendas)', routes: ['ranking_index'] },
  // v109: WhatsApp Call (ligações pelo número oficial)
  {
    key: 'WhatsappCall',
    label: 'WhatsApp Call',
    children: [
      { key: 'WhatsappCall Dashboard', label: 'Dashboard de Ligações', routes: ['whatsapp_call_dashboard'] },
      { key: 'WhatsappCall Config', label: 'Configuração (chave geral)', routes: ['whatsapp_call_config'] },
    ],
  },
  {
    key: 'Contacts',
    label: 'Contatos',
    children: [
      {
        key: 'All Contacts',
        label: 'Todos os Contatos',
        routes: ['contacts_dashboard_index', 'contacts_edit'],
      },
      { key: 'Active', label: 'Ativos', routes: ['contacts_dashboard_active'] },
      {
        key: 'Segments',
        label: 'Segmentos',
        routes: ['contacts_dashboard_segments_index', 'contacts_edit_segment'],
      },
      {
        key: 'Tagged With',
        label: 'Por Etiqueta',
        routes: ['contacts_dashboard_labels_index', 'contacts_edit_label'],
      },
    ],
  },
  {
    key: 'Companies',
    label: 'Empresas',
    children: [
      { key: 'All Companies', label: 'Todas as Empresas', routes: ['companies_dashboard_index'] },
    ],
  },
  {
    key: 'Reports',
    label: 'Relatórios',
    children: [
      { key: 'Report Overview', label: 'Visão Geral', routes: ['account_overview_reports'] },
      { key: 'Report Conversation', label: 'Conversas', routes: ['conversation_reports'] },
      { key: 'Reports Agent', label: 'Agentes', routes: ['agent_reports_index', 'agent_reports_show'] },
      { key: 'Reports Label', label: 'Etiquetas', routes: ['label_reports_index'] },
      { key: 'Reports Inbox', label: 'Caixas', routes: ['inbox_reports_index', 'inbox_reports_show'] },
      { key: 'Reports Team', label: 'Times', routes: ['team_reports_index', 'team_reports_show'] },
      { key: 'Reports CSAT', label: 'CSAT', routes: ['csat_reports'] },
      { key: 'Reports SLA', label: 'SLA', routes: ['sla_reports'] },
      { key: 'Reports Bot', label: 'Bot', routes: ['bot_reports'] },
    ],
  },
  {
    key: 'Campaigns',
    label: 'Campanhas',
    children: [
      { key: 'Live chat', label: 'Live Chat', routes: ['campaigns_livechat_index'] },
      { key: 'SMS', label: 'SMS', routes: ['campaigns_sms_index'] },
      { key: 'WhatsApp', label: 'WhatsApp', routes: ['campaigns_whatsapp_index'] },
    ],
  },
  {
    key: 'Settings',
    label: 'Configurações',
    children: [
      { key: 'Settings Account Settings', label: 'Configurações da Conta', routes: ['general_settings_index'] },
      // v110: chave geral do chat interno
      { key: 'Settings Chat Interno', label: 'Chat Interno (liga/desliga)', routes: ['chat_interno_settings_index'] },
      { key: 'Settings Captain', label: 'Captain IA', routes: ['captain_settings_index'] },
      { key: 'Settings Agents', label: 'Agentes', routes: ['agent_list'] },
      {
        key: 'Settings Teams',
        label: 'Times',
        routes: [
          'settings_teams_list', 'settings_teams_new', 'settings_teams_finish',
          'settings_teams_add_agents', 'settings_teams_show', 'settings_teams_edit',
          'settings_teams_edit_members', 'settings_teams_edit_finish',
        ],
      },
      {
        key: 'Settings Agent Assignment',
        label: 'Atribuição de Agentes',
        routes: [
          'assignment_policy_index', 'agent_assignment_policy_index',
          'agent_assignment_policy_create', 'agent_assignment_policy_edit',
          'agent_capacity_policy_index', 'agent_capacity_policy_create',
          'agent_capacity_policy_edit',
        ],
      },
      {
        key: 'Settings Inboxes',
        label: 'Caixas de Entrada',
        routes: [
          'settings_inbox_list', 'settings_inbox_show', 'settings_inbox_new',
          'settings_inbox_finish', 'settings_inboxes_page_channel', 'settings_inboxes_add_agents',
        ],
      },
      { key: 'Settings Labels', label: 'Etiquetas', routes: ['labels_list'] },
      { key: 'Settings Custom Attributes', label: 'Atributos Personalizados', routes: ['attributes_list'] },
      { key: 'Settings Automation', label: 'Automação', routes: ['automation_list'] },
      { key: 'Settings Agent Bots', label: 'Agent Bots', routes: ['agent_bots'] },
      { key: 'Settings Macros', label: 'Macros', routes: ['macros_wrapper'] },
      { key: 'Settings Canned Responses', label: 'Respostas Prontas', routes: ['canned_list'] },
      { key: 'Settings Integrations', label: 'Integrações', routes: ['settings_applications'] },
      { key: 'Settings Audit Logs', label: 'Logs de Auditoria', routes: ['auditlogs_list'] },
      { key: 'Settings Custom Roles', label: 'Perfis Personalizados', routes: ['custom_roles_list'] },
      { key: 'Settings Bank Settings', label: 'Credenciais de Bancos', routes: ['bank_settings_index'] },
      { key: 'Settings Sla', label: 'SLA', routes: ['sla_list'] },
      { key: 'Conversation Workflow', label: 'Fluxo de Conversas', routes: ['conversation_workflow_index'] },
      { key: 'Settings Security', label: 'Segurança', routes: ['security_settings_index'] },
      { key: 'Settings Billing', label: 'Faturamento', routes: ['billing_settings_index'] },
    ],
  },
];

// Mapa route name -> feature key (para o guard). So nos que possuem `routes`.
const buildRouteMap = () => {
  const map = {};
  const visit = nodes => {
    nodes.forEach(node => {
      (node.routes || []).forEach(routeName => {
        map[routeName] = node.key;
      });
      if (node.children) visit(node.children);
    });
  };
  visit(ACCESS_CONTROL_CATALOG);
  return map;
};

export const ROUTE_TO_FEATURE_KEY = buildRouteMap();

export const featureKeyForRouteName = routeName =>
  routeName ? ROUTE_TO_FEATURE_KEY[routeName] || null : null;

// Blocklist de UI do usuario (custom_attributes.ui_blocklist).
// O super admin (id 1) NUNCA e restringido.
export const getBlockedFeatureKeys = user => {
  if (!user || user.id === 1) return [];
  const ca = user.custom_attributes || {};
  return Array.isArray(ca.ui_blocklist) ? ca.ui_blocklist : [];
};

// Remove recursivamente da arvore de menus os nos cuja key (name) esta bloqueada.
// v91: se TODOS os filhos de um grupo foram bloqueados e o grupo nao tem rota
// propria (`to`), o grupo some junto (evita header morto na Sidebar).
export const stripBlockedMenuItems = (items, blockedKeys = []) => {
  if (!blockedKeys.length) return items;
  return items
    .filter(item => !blockedKeys.includes(item.name))
    .map(item =>
      item.children
        ? { ...item, children: stripBlockedMenuItems(item.children, blockedKeys) }
        : item
    )
    .filter(item => !(Array.isArray(item.children) && item.children.length === 0 && !item.to));
};

// v52: primeira tela LIBERADA para o usuario (route name), percorrendo o
// catalogo na ordem do menu. Pula nos bloqueados (e seus filhos). Usado pelo
// guard (routeHelpers) como destino de aterrissagem quando a home/conversas
// esta bloqueada, evitando o loop de redirect "fica so carregando".
// Retorna null se NADA estiver liberado.
export const firstAllowedRouteName = user => {
  const blocked = getBlockedFeatureKeys(user);
  let found = null;
  const visit = nodes =>
    nodes.forEach(node => {
      if (found || blocked.includes(node.key)) return;
      if (node.routes && node.routes.length) {
        found = node.routes[0];
        return;
      }
      if (node.children) visit(node.children);
    });
  visit(ACCESS_CONTROL_CATALOG);
  return found;
};
